import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  ChangePasswordPayload,
  UpdateClientPayload,
  UpdateUsersPayload,
  UserNotificationPayload,
  validateBusinessPayload,
} from "type/setting";

export const settings = createApi({
  reducerPath: "settings",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    updateUsers: builder.mutation<any, UpdateUsersPayload>({
      query: (body) => ({
        url: `update-users`,
        method: "PUT",
        body,
      }),
    }),
    validateBusiness: builder.mutation<any, validateBusinessPayload>({
      query: (body) => ({
        url: `onboarding/validateData`,
        method: "POST",
        body,
      }),
    }),
    updateClient: builder.mutation<any, UpdateClientPayload>({
      query: (body) => ({
        url: `clients`,
        method: "PUT",
        body,
      }),
    }),
    changePassword: builder.mutation<any, ChangePasswordPayload>({
      query: (body) => ({
        url: `user/changePassword`,
        method: "POST",
        body,
      }),
    }),
    userNotification: builder.mutation<any, UserNotificationPayload>({
      query: (body) => ({
        url: `user-notification`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useUpdateUsersMutation,
  useUpdateClientMutation,
  useValidateBusinessMutation,
  useChangePasswordMutation,
  useUserNotificationMutation,
} = settings;
